import React, { lazy, Suspense } from 'react';
import { LoadingSpinner } from '@miroculus/miroculus-ui';
const ProtocolRouting = lazy(() => import(
/* webpackChunkName: 'protocol-routing' */
'./ProtocolRouting'));
const loading = React.createElement(LoadingSpinner, { message: "Loading routing..." });
const ProtocolRoutingLoader = () => (React.createElement(Suspense, { fallback: loading },
    React.createElement(ProtocolRouting, null)));
export default ProtocolRoutingLoader;
